import SiafLiteApiRepository from "../../external/siafLiteApi";

class LogsService {
  constructor() {
    this.urlBase = "/logs";
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBase).get(filter);
  }

  getDetalhe(filter) {
    return new SiafLiteApiRepository(`${this.urlBase}/detalhe`).get(filter);
  }
}

export default LogsService;
